import { Box, Button } from '@mui/material'
import React from 'react'
import CaretLeft from '../../assets/CaretLeft.svg'
import {  useNavigate } from 'react-router-dom'
export default function NavigatePage() {
    const navigate = useNavigate();

    const handleGoBack = () => {
      navigate(-1); // Goes back to the previous page
    };
  return (
    <Box sx={{ alignSelf: 'flex-start', marginBottom: 4 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <img src={CaretLeft} alt="Arrow" style={{ width: 15, height: 15 }} />
      <Button onClick={handleGoBack} sx={{ color: '#929294', textDecoration: 'none', cursor: 'pointer', border: 'none', textTransform:'capitalize' }}>
        Go Back
      </Button>
    </Box>
  </Box>
  )
}
